import { brand, brandDark } from "@/shared/lib/safecheckBrand";

const darkColorMap: Record<string, string> = {
  [brand.navy]: brandDark.navy,
  [brand.navyLight]: brandDark.navyLight,
  [brand.navyDark]: brandDark.navyDark,
  [brand.lime]: brandDark.lime,
  [brand.limeDark]: brandDark.limeDark,
};

export function resolveChartColor(color: string, isDark: boolean): string {
  if (!isDark) return color;
  return darkColorMap[color] ?? color;
}

export function resolveChartData<T extends { color: string }>(
  data: T[],
  isDark: boolean,
): T[] {
  if (!isDark) return data;
  return data.map((item) => ({
    ...item,
    color: resolveChartColor(item.color, true),
  }));
}
